module.exports = "https://shop.vibeslife.ca/_next/static/images/iphone-7af3d6cb733443bc82c0cb2e7f8893a1.png";